// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"ee710479","996":"e03c2d00"}[chunkId] + ".chunk.css";
};